import React, { useMemo } from 'react';
import { Text } from '@fluentui/react-components';
import { useDataSelection } from '@bingads-webui-react/data-selection';

import { I18n } from '../types';
import { useSelectionCountStyles } from './selection-count-styles';

interface SelectionCountProps {
  i18n: I18n;
}

export const SelectionCount: React.FC<SelectionCountProps> = ({ i18n }) => {
  const classes = useSelectionCountStyles();

  const { dataSelection } = useDataSelection();

  const count = useMemo(
    () => dataSelection.length,
    [dataSelection],
  );

  return (
    <Text className={classes.root}>
      {i18n.getString(_TL_('Total selected: {{count}}'), { count })}
    </Text>
  );
};
